const EN_US_TIME_AGO_CUSTOM_LABELS = ['sec.', 'min.', 'hour', 'day', 'week', 'mth.', 'year']

export function buildCustomTimeAgoEnLabels(diff: number, idx: number): [string, string] {
  if (idx === 0) return ['just now', 'right now']

  let unit = EN_US_TIME_AGO_CUSTOM_LABELS[Math.floor(idx / 2)]
  if (diff > 1 && !unit.endsWith('.')) unit += 's'

  return [`${diff} ${unit} ago`, `in ${diff} ${unit}`]
}
